import React, { FunctionComponent } from "react";
import "./ntb.scss";
import Card from "../../components/cards/card";

import forwardIcon from "../../assets/images/forwardIcon.svg";
import rewardIcon from "../../assets/images/rewardIcon.svg";
import percent from "../../assets/images/percent.svg";
import version from "../../assets/images/version.svg";
import debitCardIcon from "../../assets/images/debitCardIcon.svg";
import airplane from "../../assets/images/airplane.svg";
import gift from "../../assets/images/gift.svg";
import priorityBanner from "../../assets/images/priorityBanner.jpg";
import scrollImage1 from "../../assets/images/scrollImage1.jpg";
import scrollMobImage1 from "../../assets/images/scrollMobImage1.jpg";
import scrollMobImage2 from "../../assets/images/scrollMobImage2.jpg";
import scrollMobImage3 from "../../assets/images/scrollMobImage3.jpg";
import scrollImage2 from "../../assets/images/scrollImage2.jpg";
import scrollImage3 from "../../assets/images/scrollImage3.jpg";
import button_bg from "../../assets/images/button_bg.svg";
import burgundyBanner from "../../assets/images/burgundyBanner.jpg";
import fundAccount from "../../assets/images/fundAccount.svg";
import kyc from "../../assets/images/kyc.svg";
import details from "../../assets/images/details.svg";
import verification from "../../assets/images/verification.svg";

import Text from "../../components/typography/typgraphy";
import {
  NTB_MAIN_HEADING,
  NTB_SUB_HEADING,
  ACCOUNT_BURGUNDY,
  ACCOUNT_PRIORITY,
  PRIORITY_BENEFIT_1,
  PRIORITY_BENEFIT_2,
  PRIORITY_BENEFIT_3,
  PRIORITY_BENEFIT_4,
  PRIORITY_FOOTER,
  BURGUNDY_BENEFIT_1,
  BURGUNDY_BENEFIT_2,
  BURGUNDY_BENEFIT_3,
  BURGUNDY_BENEFIT_4,
  BURGUNDY_BENEFIT_5,
  BURGUNDY_FOOTER,
} from "../../constants/messages";
import Carousel from "../../components/carousel/carousel";
import CustomTimeline from "../../components/timeline/timeline";
import AxisButton from "../../components/button/button";
import { LEAP_REDIRECTION_ENDPOINT } from "../../constants/constants";
import { getTransactionIdFromURL } from "../../constants/utils";

const NewToBank: FunctionComponent = () => {
  const txnId = getTransactionIdFromURL()

  const data = [
    {
      content: "VERIFICATION VIA PAN AND AADHAAR",
      icon: verification,
    },
    {
      content: "FILL IN YOUR DETAILS",
      icon: details,
    },
    {
      content: "COMPLETE YOUR KYC VIA VIDEO CALL",
      icon: kyc,
    },
    {
      content: "FUND YOUR ACCOUNT",
      icon: fundAccount,
    },
  ];

  return (
    <div className="ntb-screen">
      <div className="ntb-container">
        <div className="ntb-carousel">
          <Carousel>
            <div className="carousel-image">
              <img
                className="card-mains-image"
                src={scrollImage1}
                alt="account banner"
              />
            </div>
            <div className="carousel-image">
              <img
                className="card-mains-image"
                src={scrollImage2}
                alt="account banner"
              />
            </div>
            <div className="carousel-image">
              <img
                className="card-mains-image"
                src={scrollImage3}
                alt="account banner"
              />
            </div>
          </Carousel>
        </div>
        <div className="ntb-mobile-carousel">
          <Carousel>
            <div className="carousel-image-mob">
              <img
                className="card-mobile-image"
                src={scrollMobImage1}
                alt="account banner"
              />
            </div>
            <div className="carousel-image-mob">
              <img
                className="card-mobile-image"
                src={scrollMobImage2}
                alt="account banner"
              />
            </div>
            <div className="carousel-image-mob">
              <img
                className="card-mobile-image"
                src={scrollMobImage3}
                alt="account banner"
              />
            </div>
          </Carousel>
        </div>
        <div className="ntb-timeline">
          <Card>
            <div className="timeline-header">
              <Text fontSize={18} fontWeight={700}>
                Apply in 4 easy steps
              </Text>
            </div>
            <Text className="timeline-content" fontSize={14} fontWeight={500}>
              <CustomTimeline data={data} />
            </Text>
          </Card>
        </div>
        <div className="ntb-header">
          <Text className="timing-text" fontSize={16} fontWeight={700}>
            We are Open 7 days of the week{" "}
            <span className="timings">9:00 AM TO 8:00 PM</span>
          </Text>
          <Text className="main-heading-text" fontSize={20} fontWeight={1000}>
            {NTB_MAIN_HEADING}
          </Text>
          <Text className="sub-heading-text" fontSize={12} fontWeight={1000}>
            {NTB_SUB_HEADING}
          </Text>
        </div>
        <div className="ntb-card">
          <Card>
            <div className="card-container">
              <div className="card-header">
                <Text
                  className="card-header-text"
                  fontSize={18}
                  fontWeight={700}
                >
                  {ACCOUNT_PRIORITY}
                </Text>
                <AxisButton className="leap-btn" href={LEAP_REDIRECTION_ENDPOINT(txnId)} target="_blank">
                  <img
                    className="more-btn"
                    src={forwardIcon}
                    alt="more details..."
                  />
                </AxisButton>
              </div>
              <div className="card-body">
                <img
                  className="card-main-image"
                  src={priorityBanner}
                  alt="account banner"
                />
                <div className="card-benefit">
                  <img className="body-image" src={rewardIcon} alt="rewards" />
                  <Text className="benefit-text">{PRIORITY_BENEFIT_1}</Text>
                </div>
                <div className="card-benefit">
                  <img className="body-image" src={percent} alt="rewards" />
                  <Text className="benefit-text">{PRIORITY_BENEFIT_2}</Text>
                </div>
                <div className="card-benefit">
                  <img className="body-image" src={version} alt="rewards" />
                  <Text className="benefit-text">{PRIORITY_BENEFIT_3}</Text>
                </div>
                <div className="card-benefit">
                  <img
                    className="body-image"
                    src={debitCardIcon}
                    alt="rewards"
                  />
                  <Text className="benefit-text">{PRIORITY_BENEFIT_4}</Text>
                </div>
              </div>

              <div className="card-footer">
                <Text className="footer-text">{PRIORITY_FOOTER}</Text>
              </div>
            </div>
          </Card>

          <Card>
            <div className="card-container">
              <div className="card-header">
                <Text
                  className="card-header-text"
                  fontSize={18}
                  fontWeight={700}
                >
                  {ACCOUNT_BURGUNDY}
                </Text>
                <AxisButton className="leap-btn" href={LEAP_REDIRECTION_ENDPOINT(txnId)} target="_blank">
                  <img
                    className="more-btn"
                    src={forwardIcon}
                    alt="more details..."
                  />
                </AxisButton>
              </div>
              <div className="card-body">
                <img
                  className="card-main-image"
                  src={burgundyBanner}
                  alt="account banner"
                />
                <div className="card-benefit">
                  <img className="body-image" src={version} alt="rewards" />
                  <Text className="benefit-text">{BURGUNDY_BENEFIT_1}</Text>
                </div>
                <div className="card-benefit">
                  <img className="body-image" src={gift} alt="rewards" />
                  <Text className="benefit-text">{BURGUNDY_BENEFIT_2}</Text>
                </div>
                <div className="card-benefit">
                  <img className="body-image" src={airplane} alt="rewards" />
                  <Text className="benefit-text">{BURGUNDY_BENEFIT_3}</Text>
                </div>
                <div className="card-benefit">
                  <img className="body-image" src={rewardIcon} alt="rewards" />
                  <Text className="benefit-text">{BURGUNDY_BENEFIT_4}</Text>
                </div>
                <div className="card-benefit">
                  <img
                    className="body-image"
                    src={debitCardIcon}
                    alt="rewards"
                  />
                  <Text className="benefit-text">{BURGUNDY_BENEFIT_5}</Text>
                </div>
              </div>

              <div className="card-footer">
                <Text className="footer-text">{BURGUNDY_FOOTER}</Text>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default NewToBank;
